export enum SearchOptionTypes {
	SINGLE_FROM_RANGE = 'singleFromRange', // Single value from a range, appears like range but only 1 value
	RANGE = 'range',// range of values
	LIST = 'list',// List of values used for drop downs
	MULTI_LIST = 'multiList',// List of values which can have multiple selections, for example, gender
	SINGLE_LIST = 'singleList',// list of values layed out like multiList but only one can be selected from
	TEXT = 'text'// Custom text input by the user
}

// Consts used for identifying which dashboard sub page should be highlighted
export enum DashboardSubPages {
	MAIN = 'main',
	CHATS = 'chats',
	BOOKING_DETAILS = 'bookingDetails',
	REVIEWS = 'reviews',
	SAVED_INSTRUCTORS = 'savedInstructors',
	EARNINGS = 'earnings',
	SETTINGS = 'settings',
	CUSTOMERS = 'customers',
	INSTRUCTOR = 'instructor',
	INSTRUCTORS = 'instructors',
	ADMIN_CHATS = 'chats',
	SUPPORT = 'support'
}

export enum AccountStatus {
	ACTIVE = 'ACTIVE',
	VERIFY_EMAIL = 'VERIFY_EMAIL',
	ID_NOT_PROVIDED = 'ID_NOT_PROVIDED',
	CERTIFICATE_NOT_PROVIDED = 'CERTIFICATE_NOT_PROVIDED',
	CERTIFICATE_UNDER_REVIEW = 'CERTIFICATE_UNDER_REVIEW',
	AWAITING_PROOF = 'AWAITING_PROOF',
	INCOMPLETE = 'INCOMPLETE',
	FLAGGED = 'FLAGGED',
	DISABLED = 'DISABLED',
	SUSPENDED = 'SUSPENDED',
	BANNED = 'BANNED',
	FULLY_BOOKED = 'FULLY_BOOKED'
}

export enum DocumentStatus {
	UPLOADED = 'UPLOADED',
	CONFIRMED = 'CONFIRMED',
	DENIED = 'DENIED'
}

export enum InteractionStatus {
	PAYMENT_IN_PROGRESS = 'PAYMENT_IN_PROGRESS', // Interaction created and waiting on payment to begin
	PAYMENT_FAILED = 'PAYMENT_FAILED', // Payment failed
	ACTIVE = 'ACTIVE', // Interaction in progress
	WAITING_FOR_VIDEOS = 'WAITING_FOR_VIDEOS',
	REVIEW = 'REVIEW', // Interaction done and waiting on review to complete
	COMPLETE = 'COMPLETE', // Interaction completed
	FLAGGED = 'FLAGGED', // Flagged for some reason
	UNKNOWN = 'UNKNOWN'
}

export type ChatMessage = {
	message: string
	type: 'txt' | 'video'
	sourceId: string
	time: string
	profileImgUrl: string
}

export enum EDITING_STATE {
	IDLE = 'IDLE',
	PLAYING = 'PLAYING',
	RECORDING = 'RECORDING',
	RECORDING_WHILE_PLAYING = 'RECORDING_WHILE_PLAYING',
	DRAWING = 'DRAWING',
	DRAWING_LINE = 'DRAWING_LINE',
	DRAWING_SHAPE = 'DRAWING_SHAPE'
}

export enum EDITING_OPTIONS {
	DRAW = 'DRAW',
	LINE = 'LINE',
	SHAPE = 'SHAPE'
}